import Vue from 'vue'
import Vuex from 'vuex'
import http from '@utils/http'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isDialogAccountSize: false,
    userInfo: {},
    isShowNav: true,
    device: 'pc',
    currMarketId: '',
    currMarket: '',
    breadcrumbs: [],
    currCountryInfo: {}
  },
  mutations: {
    SET_USER_INFO (state, data) {
      state.userInfo = data
      // identity：0=用户，1=主代理；代理等级使用 promotion_level
    },
    SET_IS_DIALOG_ACCOUNT_SIZE (state, data) {
      state.isDialogAccountSize = data
    },
    SET_IS_SHOW_NAV (state, data) {
      state.isShowNav = data
    },
    SET_DEVICE (state, data) {
      state.device = data
    },
    SET_MARKET_ID (state, data) {
      state.currMarketId = data
    },
    SET_NATIONAL_MARKET_CURRENCY (state, data) {
      state.currMarket = data
    },
    SET_CURRENT_COUNTRY_INFO (state, data) {
      state.currCountryInfo = data
    },
    SET_BREADCRUMBS (state, data) {
      state.breadcrumbs = data
    }
  },
  actions: {
    getUserInfo ({ commit, dispatch }) {
      return http.get('/api/user/info').then((res) => {
        commit('SET_USER_INFO', res)
        return res
      })
    }
  },
  modules: {}
})
